import { createSelectorOption } from './Selector.Helpers';
import RadioButtonGroup from '../../Common/RadioButtonGroup/RadioButtonGroup';
import React from 'react';
import Selector from '../../../types/report/Selector';

interface Props {
    selectorNumber: number | null;
    defaultName: string;
    selectors: Selector[];
    onSelectorSelected: (number: number) => void;
}

class SelectorComponent extends React.Component<Props, { scrollLeft: number }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            scrollLeft: 0
        }

        this.onSelectorSelected = this.onSelectorSelected.bind(this);
    }

    onSelectorSelected(value: string, scrollLeft?: number): void {

        this.setState({ scrollLeft: scrollLeft || 0 }, () => {

            this.props.onSelectorSelected(parseInt(value));
        });

    }

    render(): JSX.Element {

        if (this.props.selectors.length === 0) {

            return (<></>);
        }

        return (
            <RadioButtonGroup
                className='sticky min-height-44px padding-10px overflow-x-auto'
                labelClassName='allow-25ch-per-row'
                options={this.props.selectors.map((selector) => { return createSelectorOption(selector, this.props.defaultName) })}
                value={(this.props.selectorNumber as number)?.toString() || ''}
                onChange={this.onSelectorSelected}
                name={this.props.defaultName}
                scrollLeft={this.state.scrollLeft} />
        );
    }
}

export default SelectorComponent;
